import axios from 'axios';
import { setSession } from 'src/utils/jwt';
import { apiServiceProviderUrl } from './config';

const withCredentials = true;

const executeRequest = (method, url, data, requiredStatusCode, contentType = 'application/json', onProgressChanged) => {
  const headers = { 'Content-Type': contentType };

  return new Promise((resolve, reject) => {
    axios({
      url: `${apiServiceProviderUrl}/${url}`,
      data,
      withCredentials,
      method,
      headers,
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgressChanged && onProgressChanged(percentage);
      },
    })
      .then((response) => {
        const data = response.data;
        if (data.isSuccess) resolve(data.result);
        else handleError(method, url, data, contentType).then(resolve).catch(reject);
      })
      .catch((error) => reject(translateErrorMessage(error.message)));
  });
};

const direct = (method, url, data, requiredStatusCode) => {
  const headers = { 'Content-Type': 'application/json' };

  return new Promise((resolve, reject) => {
    axios({
      url: `${apiServiceProviderUrl}/${url}`,
      data,
      withCredentials,
      method,
      headers,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(translateErrorMessage(error.message)));
  });
};

const handleError = (method, url, result, contentType) => {
  return new Promise((resolve, reject) => {
    if (result.errorCode === '401') {
      let headers = { 'Content-Type': contentType };

      axios({
        url: `${apiServiceProviderUrl}/authentication/refresh`,
        data: null,
        withCredentials,
        method: 'get',
        headers,
      })
        .then((res) => {
          const response = res.data;
          if (!response.isSuccess) return reject({ message: response.errorMessage, code: response.errorCode });
          setSession(response.result.token);
          headers = { 'Content-Type': contentType };
          axios({ url: `${apiServiceProviderUrl}/${url}`, data: result, withCredentials, method, headers })
            .then((mainResponse) => {
              const data = mainResponse.data;
              if (data.isSuccess) resolve(data.result);
              else reject({ message: data.errorMessage, code: data.errorCode });
            })
            .catch((error) => reject({ message: error.errorMessage, code: result.errorCode }));
        })
        .catch(() => reject({ message: result.errorMessage, code: result.errorCode }));
    } else reject(new Error(result.errorMessage));
  });
};

const translateErrorMessage = (message) => {
  if (message === 'Network Error') return new Error('network-error');
  else return new Error(message);
};

const downloadContent = async (downloadUrl, mimeType) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = {};

      var response = await axios.get(downloadUrl, {
        responseType: 'arraybuffer',
        headers,
        withCredentials,
      });

      const contentType = response.headers['content-type'];
      if (contentType.includes('application/json')) {
        const text = new TextDecoder().decode(response.data);
        var json = JSON.parse(text);
        var message = json.errorMessage || response.title;

        reject(new Error(message));
      } else {
        var blob = new Blob([response.data], { type: mimeType });
        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        let filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);
        const matches = response.headers['content-disposition'].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

        if (matches && matches.length > 0) {
          const _filename = matches[1].replace(/['"]/g, '');
          filename = decodeURIComponent(_filename.trim());
        }

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);

        // Append the link to the document body
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Clean up
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
        resolve();
      }
    } catch (error) {
      // Handle error, e.g., display error message
    }
  });
};

const makeblob = async (imageUrl, mimeType) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = {};

      axios
        .get(imageUrl, {
          responseType: 'arraybuffer',
          headers,
          withCredentials,
        })
        .then((response) => {
          const contentType = response.headers['content-type'];
          if (contentType.includes('application/json')) {
            const text = new TextDecoder().decode(response.data);
            var json = JSON.parse(text);
            var message = json.errorMessage || response.title;
            reject(new Error(message));
          } else {
            var blob = new Blob([response.data], { type: mimeType });
            resolve(window.URL.createObjectURL(blob));
          }
        })
        .catch((err) => {
          if (err.response.status === 404) reject(new Error('drive-not-found'));
          else reject(new Error('bad-request'));
        });
    } catch (error) {
      // Handle error, e.g., display error message
    }
  });
};

export const get = (url, requiredStatusCode = false) => executeRequest('get', url, null, requiredStatusCode);
export const post = (url, data, requiredStatusCode = false) => executeRequest('post', url, data, requiredStatusCode);
export const upload = (url, data, onUploadProgress) => executeRequest('post', url, data, false, '', onUploadProgress); //"multipart/form-data"
export const put = (url, data, requiredStatusCode = false) => executeRequest('put', url, data, requiredStatusCode);
export const remove = (url, requiredStatusCode = false) => executeRequest('delete', url, null, requiredStatusCode);
export const download = (url, mimeType) => downloadContent(url, mimeType);
export const blob = (url, mimeType) => makeblob(url, mimeType);
export const directCall = (url) => direct('get', url, null);
